import { useEffect } from 'react'
import { Link } from 'react-router-dom'

const Home = () => {
  useEffect(() => {
    document.title = "Haight & Ashbury - Reimagining the Doolan-Larson Building"
  }, [])

  return (
    <div>
      {/* Hero Section */}
      <section className="relative min-h-[70dvh] md:min-h-[100dvh] flex items-center justify-center">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: "url('/content/images/Doolan_Larson_haight_facade_large_expanded-scaled.jpg')"
          }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        </div>
        
        <div className="relative z-10 text-center text-white px-4 max-w-4xl mx-auto">
          <h1 className="mb-6">
            Reimagining the Doolan-Larson Building for a New Generation
          </h1>
          <p className="text-[20px] leading-[26px] tracking-[-0.02em] mb-8">
            The Corner of Haight & Ashbury
          </p>
          <Link to="/press-release" className="btn-primary inline-block">
            Read the Press Release →
          </Link>
        </div>
      </section>

      {/* Welcome Section */}
      <section className="bg-white">
          <div className="grid md:grid-cols-2 items-stretch">
            <div className="section-padding">
              <div className="max-w-2xl md:ml-auto md:pr-10">
              <h2 className="text-haight-navy mb-8 text-left">
                Welcome!
              </h2>
              <div className="space-y-6 text-lg text-gray-700 text-left">
                <p>
                  At the corner of Haight and Ashbury stands the historic Doolan-Larson House and Storefronts, a landmark of the counterculture and a symbol of San Francisco's ongoing role as a nexus of cultural and political change.
                </p>
                <p>
                  In 2017, Norm Larson gifted this property to San Francisco Heritage to protect its legacy and unlock its public potential. That vision is now advancing into its next chapter, as the project moves from open inquiry into active development and public dialogue.
                </p>
                <p>
                  San Francisco Heritage is advancing plans to transform the historic Doolan-Larson House and Storefronts at Haight and Ashbury into a new music and cultural center in partnership with nonprofit public broadcaster KEXP and Blue Bear School of Music.
                </p>
                <p>
                  <Link
                    to="/press-release"
                    className="underline underline-offset-4 text-haight-navy hover:text-black"
                  >
                    Read the September 2026 Press Release regarding the selection of KEXP.
                  </Link>
                </p>
                <p>
                  This website remains your gateway to the process. We welcome your continued participation as we work together to create a living center that honors the past and inspires what's possible ahead.
                </p>
              </div>
              </div>
            </div>

            <div className="w-full h-full m-0 p-0 self-stretch">
              <img
                src="/content/images/Time-of-Change-rehearsals_April_2021.jpg"
                alt="Doolan-Larson House and Storefronts exterior"
                className="block w-full h-auto min-h-[240px] max-h-[70dvh] md:h-full md:min-h-full md:max-h-none object-cover"
              />
            </div>
          </div>
      </section>

      {/* Treasure Block */}
      <section className="section-padding bg-haight-navy text-white">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-haight-gold mb-8">
              The Doolan-Larson House & Storefronts: a National Historic Treasure
            </h2>
            <div className="space-y-6 text-lg">
              <p>
                The Doolan-Larson House is a National Historic Treasure, distinguished both by its location at Haight &amp; Ashbury and by its architectural integrity. It offers a rare chance to explore San Francisco's role in shaping social, cultural, and political movements—and the city's enduring influence on the national consciousness.
              </p>
              <p>
                Haight &amp; Ashbury remains the epicenter of the counterculture movement, inspiring new ways of thinking and living. People came to San Francisco from across the country in search of acceptance, meaning, and opportunity. What happens next at the Doolan-Larson buildings is your chance to become part of that story.
              </p>
              <p>
                <Link to="/heritage" className="btn-primary inline-block">
                  LEARN MORE →
                </Link>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Home
